import "./svg/nav-savings-filled.svg"

export default {
    name: "nav-savings-filled",
    viewBox: "24 24",
}
